<div class="sectionContainer paddedContent">
  <div class="flex-container">
    <div style="flex: 1">
      <h2>Log phone call</h2>

      <div class="column">
        <app-text-input
          [label]="'Date'"
          [readonly]="false"
          [required]="true"
          [(ngModel)]="call.date"
        ></app-text-input>
      </div>
      <div class="column">
        <app-text-input
          [label]="'Time'"
          [readonly]="false"
          [required]="true"
          [(ngModel)]="call.time"
        ></app-text-input>
      </div>
      <div class="column">
        <app-text-input
          [label]="'Talked to'"
          [readonly]="false"
          [required]="false"
          [(ngModel)]="call.name"
        ></app-text-input>
      </div>
      <div class="column">
        <input type="radio" name="callDirection" /> Incoming
        <input type="radio" name="callDirection" value="outgoing" /> Outgoing
      </div>
      <div class="column">
        <app-multiline-input
          [label]="'Summary'"
          [readonly]="false"
          [required]="false"
          [(ngModel)]="call.summary"
        ></app-multiline-input>
      </div>

      <div class="column" style="text-align: center; margin-top: 15px">
        <input
          type="button"
          class="button_secondary button_var_2 button_right-spacing"
          value="Save"
        />
        <input
          type="button"
          class="button_secondary button_var_2"
          value="Cancel"
        />
      </div>
    </div>
  </div>
</div>
